import { useQuery } from "react-query";
import { apiGet } from "./api";
import { OrganizationAiCreditBalance } from "../types/organizationAiCreditBalance";

const getOrganizationAiCreditBalance = async (): Promise<OrganizationAiCreditBalance> => {
  return await apiGet({ path: "/ai_credits" });
};

export function useOrganizationAiCreditBalance() {
  return useQuery<OrganizationAiCreditBalance>(["organizationAiCreditBalance"], getOrganizationAiCreditBalance, {
    refetchOnWindowFocus: false,
  });
}
